import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Award } from "lucide-react";

/**
 * Shows a "View Certificate" button when threshold met.
 * Threshold: accuracy_percent >= 90 AND wpm >= 100
 */
export default function CertificateBadge({ attemptId, accuracy, wpm }) {
  const qualifies = accuracy >= 90 && wpm >= 100;
  if (!qualifies) return null;
  return (
    <div className="mt-8 border-2 border-yellow-500 bg-yellow-50 p-6 flex items-center justify-between gap-4 flex-wrap" data-testid="certificate-badge">
      <div className="flex items-center gap-4">
        <Award className="w-10 h-10 text-yellow-600" strokeWidth={1.5} />
        <div>
          <div className="text-xs uppercase tracking-[0.3em] font-bold text-yellow-800">Achievement unlocked</div>
          <div className="font-black tracking-tight text-lg">You crossed 90% accuracy at 100+ WPM.</div>
          <div className="font-mono text-sm text-yellow-900 mt-1">Claim your printable certificate now.</div>
        </div>
      </div>
      <Button asChild className="rounded-lg h-11 bg-[#0A2540] hover:bg-brand-blue text-white text-xs uppercase tracking-[0.2em] font-bold" data-testid="cert-view-btn">
        <Link to={`/certificate/${attemptId}`}>View certificate</Link>
      </Button>
    </div>
  );
}
